import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M19.5 1.3a.7.7 0 0 1 .7.7v1.8H22a.7.7 0 1 1 0 1.4h-1.8V7a.7.7 0 1 1-1.4 0V5.2H17a.7.7 0 1 1 0-1.4h1.8V2a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M21.744 9.743q.254 1.09.256 2.257c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2c.777 0 1.533.089 2.258.256a6 6 0 0 0-.246 1.38 8.6 8.6 0 1 0 6.352 6.353 6 6 0 0 0 1.38-.246",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.13 13.6a.7.7 0 0 0-1.044.933l.522-.466-.522.466.002.002.002.002.007.008.02.022.071.073q.09.092.256.237c.22.192.541.443.957.693a6.95 6.95 0 0 0 7.198 0c.415-.25.737-.501.957-.693a5 5 0 0 0 .326-.31l.02-.022.008-.008.002-.002.001-.001-.521-.467.522.466a.7.7 0 0 0-1.043-.934l-.007.008-.042.042a4 4 0 0 1-.186.172 5.4 5.4 0 0 1-.76.55 5.55 5.55 0 0 1-5.753 0 5.4 5.4 0 0 1-.76-.55 4 4 0 0 1-.227-.214M10 10.343a1 1 0 1 1-2 0 1 1 0 0 1 2 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9 11.343a1 1 0 1 0 0-2 1 1 0 0 0 0 2m7-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15 11.343a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=AddEmojiIcon24.js.map